"use client";

import { Brush, Clock, Scissors } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NosServicesSpCialisS() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const disciplines = [{
    numeral: "I",
    icon: Scissors,
    title: "Débouchage de Drains",
    description: "Une intervention chirurgicale pour vos canalisations. Nous utilisons des équipements de pointe pour éliminer les obstructions les plus tenaces, rétablissant un débit optimal sans compromettre l'intégrité de votre tuyauterie.",
    toolsLabel: "ÉQUIPEMENT",
    tools: "Nettoyage haute pression · Furet mécanique"
  }, {
    numeral: "II",
    icon: Brush,
    title: "Inspection par Caméra",
    description: "La clarté absolue sous la surface. Nos sondes haute définition localisent précisément les fissures, racines ou affaissements, vous offrant un diagnostic visuel complet avant toute décision de réparation majeure.",
    toolsLabel: "ÉQUIPEMENT",
    tools: "Sonde HD · Localisateur GPS · Rapport vidéo"
  }, {
    numeral: "III",
    icon: Clock,
    title: "Urgence & Entretien",
    description: "Une réactivité exemplaire pour le Grand Montréal. Que ce soit pour un refoulement critique ou un entretien préventif, nous intervenons avec la rigueur technique qui définit OT Solution depuis nos débuts.",
    toolsLabel: "ÉQUIPEMENT",
    tools: "Disponibilité 24/7 · Diagnostic rapide"
  }];
  return <section data-section-id="3015" id="nos-services-spécialisés" className="bg-background text-foreground relative overflow-hidden" style={{
    paddingTop: "180px",
    paddingBottom: "180px"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
      backgroundImage: "radial-gradient(circle at 1px 1px, var(--primary) 1px, transparent 0)",
      backgroundSize: "24px 24px"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
        {}
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono uppercase mb-10" style={{
          fontSize: "11px",
          letterSpacing: "0.32em",
          color: "var(--primary)"
        }}>
            — Expertise Spécialisée
          </p>
          <h2 className="font-default font-semibold leading-[1.05] text-foreground mx-auto max-w-4xl" style={{
          fontSize: "clamp(2.5rem, 6vw, 4.5rem)"
        }}>
            Deux services,
            <br />
            une précision absolue.
          </h2>
        </div>

        {}
        <div className="mt-24 grid grid-cols-1 md:grid-cols-3" style={{
        columnGap: "64px",
        rowGap: "80px"
      }}>
          {disciplines.map((discipline, i) => {
          const Icon = discipline.icon;
          return <DisciplineCard key={i} data-index={i} index={i} numeral={discipline.numeral} Icon={Icon} title={discipline.title} description={discipline.description} toolsLabel={discipline.toolsLabel} tools={discipline.tools} />;
        })}
        </div>
      </div>
    </section>;
}
function DisciplineCard({
  index,
  numeral,
  Icon,
  title,
  description,
  toolsLabel,
  tools,
  ...rest
}: {
  index: number;
  numeral: string;
  Icon: React.ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
  title: string;
  description: string;
  toolsLabel: string;
  tools: string;
  [key: string]: unknown;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} {...rest} className={`group relative flex flex-col text-center transition-all ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
    transitionDuration: "900ms",
    transitionDelay: `${index * 150}ms`
  }}>
      {}
      <div className="flex justify-center mb-8">
        <Icon className="text-foreground/80 group-hover:text-primary transition-colors duration-500" strokeWidth={1.5} style={{
        width: "64px",
        height: "64px"
      }} />
      </div>

      {}
      <p className="font-mono mb-6" style={{
      fontSize: "18px",
      color: "var(--primary)",
      letterSpacing: "0.15em"
    }}>
        [{numeral}]
      </p>

      {}
      <h3 className="font-default font-semibold text-foreground mb-6" style={{
      fontSize: "28px",
      lineHeight: "1.2"
    }}>
        {title}
      </h3>

      {}
      <p className="font-default text-muted-foreground mx-auto max-w-xs" style={{
      fontSize: "15px",
      lineHeight: "1.75"
    }}>
        {description}
      </p>

      {}
      <div className="mt-10 mb-5 mx-auto w-16 h-px bg-border" />

      {}
      <p className="font-mono uppercase text-foreground/60 mx-auto" style={{
      fontSize: "10px",
      letterSpacing: "0.2em"
    }}>
        <span className="text-primary">{toolsLabel}</span>
        <span className="mx-2">·</span>
        {tools}
      </p>

      {}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 h-px w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full" />
    </div>;
}